$(document).ready(function() {

  //handleAddToCartButton();

  $('.product .options li a').click(function() {
    console.dir($(this).data());
    //Price
  	var price = $(this).data('price');
    var originalPrice = $(this).data('oprice');
    $(".visible-money").html(price);
    if(price != originalPrice){
		$(".original").html(originalPrice);
      	$(".original").show();
    }else{
    	$(".original").hide();
    }
    //Images
    var variantId = $(this).closest('li').find(':radio').val();
    var target = $(".product-slideshow-pagination-item[data-variant-id='"+variantId+"']");
    if(target.length > 0){
      var newSrc = target.data("default-res");
      var highSrc = target.data("high-res");
      var newAlt = target.data("alt");

      $(".product-big-image img").removeClass("product-no-images").attr("src", newSrc).attr("data-high-res", highSrc).attr("alt", newAlt);
      prepZoom(highSrc);
    }
    
    //Affirm - Update ammount
    var intPrice = $(this).data('price-int');
    $('.affirm-as-low-as').attr('data-amount',intPrice);
    affirm.ui.refresh(); 
  });
  
  
  var newOption = $('#quantity').find("option:selected").text();
  $('.select-wrapper').find('.selected-text').text(newOption);
  
  $('#quantity').change(function(){
  	var newOption = $('#quantity').find("option:selected").text();
  	$('.select-wrapper').find('.selected-text').text(newOption);
  });
});  

function prepZoom(highResSrc) {
    var highResSrc, newImage;
    //highResSrc = this.$el.find('img').attr('data-high-res');
    newImage = new Image();
    this.$newImage = $(newImage);
    this.$newImage.on('load', (function(_this) {
      return function() {
        var imageHeight, imageWidth, photoAreaHeight, photoAreaWidth, ratio, ratios;
        imageWidth = newImage.width;
        imageHeight = newImage.height;
        photoAreaWidth = $(".product-big-image").width();
        photoAreaHeight = $(".product-big-image").height();
        ratios = [];
        ratios.push(imageWidth / photoAreaWidth);
        ratios.push(imageHeight / photoAreaHeight);
        ratio = Math.max.apply(null, ratios);
        if (ratio >= 1 && imageWidth > photoAreaWidth && imageHeight > photoAreaHeight) {
          $(".product-big-image").addClass('zoom-enabled');
          return $(".product-image-zoom").css({
            backgroundImage: "url('" + highResSrc + "')"
          });
        } else {
          $(".product-big-image").removeClass('zoom-enabled');
        }
      };
    })(this));
    return newImage.src = highResSrc;
  };

/*
function handleAddToCartButton(){

  if($(".terms-checkbox").length > 0){

      var btns = $('.add-to-cart-button:input[type="submit"]');


      disableAddToCartButtons(btns);
      $(".terms-checkbox").on('change', function(){
        if($(".terms-checkbox").is(':checked')){
            enableAddToCartButtons(btns);
        }else{
            disableAddToCartButtons(btns);
        }
      });
  }

}


function disableAddToCartButtons(btn){


    var btn_title_attr = "Please review the compatibility requirements to be able to add this product to the cart";

    btn.prop('disabled', true);
    btn.prop('title', btn_title_attr);
    btn.addClass('disabled');
}

function enableAddToCartButtons(btn){

    //var add_to_cart_btns = $('.add-to-cart-button:input[type="submit"]');
    var btn_title_attr = "Add to Cart";

    btn.prop('disabled', false);
    btn.prop('title', btn_title_attr);
    btn.removeClass('disabled');
}
*/